export const errorMessages = {
    invalidPassword: 'Invalid password',
};
